export default __webpack_public_path__ + "static/media/Anastasia_Lisina.de846f53.png";